import script from "./clinic-patients.vue?vue&type=script&setup=true&lang=js"
export * from "./clinic-patients.vue?vue&type=script&setup=true&lang=js"

import "./clinic-patients.vue?vue&type=style&index=0&id=2a49708e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a49708e"]])

export default __exports__